import React, { useState } from "react";
import PricingScreen from "./welcomePage";
import './signupFlowStyles.css'
import WelcomePage from "./welcomePage";
import VerifyScreen from "./verifyScreen";
import BillingInformation from "./billingInformation";
import TransactionCompleted from "./transactionCompleted";
import ChooseRegistration from "./chooseRegistration";
import SendEmailText from "./sendEmail";

const SignupFlow = () => {
    const [currentStep, setCurrentStep] = useState(0);

    const currentScreen = (value) => {
        setCurrentStep(value)
    }
    return (
        <>
            {currentStep == 0 && <ChooseRegistration currentScreen={(val) => currentScreen(val)} />}
            {currentStep == 1 && <WelcomePage currentScreen={(val) => currentScreen(val)} />}
            {currentStep == 2 && <SendEmailText currentScreen={(val) => currentScreen(val)} />}
            {/* {currentStep == 2 && <VerifyScreen currentScreen={(val) => currentScreen(val)} />} */}
            {currentStep == 3 && <BillingInformation currentScreen={(val) => currentScreen(val)} />}
            {currentStep == 4 && <TransactionCompleted currentScreen={(val) => currentScreen(val)} />}
        </>
    )
}
export default SignupFlow;